// extracted by mini-css-extract-plugin
export var button = "_ig-2";
export var card = "_ig-0";
export var closeButtonContainer = "_ig-3";
export var iconContainer = "_ig-1";